// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shared-step-editor-accordion-item__button[data-v-9250bf10]{display:flex;justify-content:space-between;align-items:center;width:100%;padding:16px;background:#fff;outline:none;font-weight:700;color:#231f20;border-bottom:1px solid #e5e5e5}.shared-step-editor-accordion-item__icon[data-v-9250bf10]{transition:transform .25s;transform:rotate(-90deg)}.shared-step-editor-accordion-item__open .shared-step-editor-accordion-item__icon[data-v-9250bf10]{transform:rotate(90deg)}", ""]);
// Exports
module.exports = exports;
